// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyDU9Aw5_LyHihcQ2A4zpBw9rS1PnGj7iGM",
    authDomain: "tanitutsx.firebaseapp.com",
    projectId: "tanitutsx",
    storageBucket: "tanitutsx.appspot.com",
    messagingSenderId: "840106997792",
    appId: "1:840106997792:web:d15c54011131394509e445",
    measurementId: "G-B9HRDQCHC3"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
